// extracted by mini-css-extract-plugin
module.exports = {"chat_component":"ButterBot_chat_component__33r9b","chat_popup":"ButterBot_chat_popup__V8Ey3","chat_body":"ButterBot_chat_body__okeZz","chat_icon":"ButterBot_chat_icon__jAKel"};